import { Component} from '@angular/core'; 
import { HttpClient} from '@angular/common/http'; 
import { environment } from '.../../environments/environment'; 
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter'; 
import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver';
import { AuthService } from '../../../_services';
import { process, State,aggregateBy} from '@progress/kendo-data-query'; 
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Observable';
import { SelectableSettings,DataStateChangeEvent,GridDataResult} from '@progress/kendo-angular-grid'; 
import { LoaderService } from '../../../_services/loader.service';
import Swal from 'sweetalert2'
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;

declare var $: any;

const distinctZone = data => data.filter((x, idx, xs) => xs.findIndex(y => y.zone === x.zone) === idx); 
const distinctWard = data => data.filter((x, idx, xs) => xs.findIndex(y => y.ward === x.ward) === idx); 
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'MaintenanceSummaryBrief',
  templateUrl: './summary.component.html', 
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ], 
}) 


export class MaintenanceSummaryBriefComponent {  
  labelContent:any
  public netWeight = 0
  public totalCNT = 0
  public total=0
  public totalPending=0
  public totalResolved=0
  public prjcd:any
  public totalToday=0
  public totalPendingToday=0
  public totalResolvedToday=0
  public totalMTD=0
  public totalPendingMTD=0
  public totalResolvedMTD=0
  public startDateMTD:any
  public todayFeedBack=0
  public todayObser=0
  public today:any
  complainData: any
  complainDataList:any;
  defaultStartDate:any
  defaultEndDate:any
  dateRangeModal:any
  public todayData: any
  public customData:any
  public mtdData:any  
  prjId:any; 
  totalComplain:any; 
  todayTotal:any;
  totPending:any;
  totResolved:any;
  public totalCustFeedBack=0;
  public totalCustUnderOb=0;
  complainChartList:any;
  public startDate:any;
  public endDate:any;
  dataNotFound=false;
  chartNotFound=false;
  public showLoader: boolean
  customDataNotFound=false;
  customChartNotFound=false
  custMtdFeedBack=0
  custMtdUnderObser=0
  public aggregates: any[] = [{field: 'Total', aggregate: 'sum'},{field: 'Today', aggregate: 'sum'},{field: 'Pending', aggregate: 'sum'},{field: 'Resolved', aggregate: 'sum'},{field: 'FeedBack', aggregate: 'sum'},{field: 'UnderObservation', aggregate: 'sum'}];
  public state: State = {  
    filter: {
      logic: 'and',
      filters: []
    }
  };
  public pageSize :any
  public checkboxOnly = false;
  public mode = 'multiple';
  public selectableSettings: SelectableSettings; 
  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;  
  public gridDataComplainReport: DataResult;
  VehTypeWisedata: any;
  VehcatTypeWisedata: any;
  currentVehicleCatSlected: any;
  TimeDelayWishData: any;
  FormattedTimeDelayWishData: any[];
  BreakdownStatusgraph: any;
  vehCatGraphData: any;
  MonthBreakdownStatusgraph: any;
  filterDataDeatils: any;
  PrimSecTypeWisedata: any;
  PrimSecTypeGraphData: any[];
  CostAndQtyData: any;
  topTenBreakdownVehdetails: any;
  EngineOildetailsdata: any;
  engineOilGraphData: any;
  remarksValues:{};
  remarks: any;
  monthsWisedata: any[];
  monthsName: any;
  monthsWisedataTwo: any[];
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  } 
  public distinctZone: any[]
  public distinctWard: any[]
  public complainTypeData :any
  public complainZoneWiseData :any
  public complainMonthWiseData :any
  private loadProducts(): void {
    this.gridDataComplainReport = process(this.complainData, { group: this.groups });  
  }
   constructor(private http : HttpClient ,private auth : AuthService,private loaderService: LoaderService) { 
    this.loaderService.status.subscribe((val: boolean) =>{
      this.showLoader = val;
    }); 
    var date = new Date();
    this.monthsName = moment().format('MMMM')
    this.currentVehicleCatSlected = '-';
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1); 
    this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate(); 
    this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate(); 
    this.dateRangeModal= {beginDate: {year: firstDay.getFullYear(), month: firstDay.getMonth()+1, day: firstDay.getDate()}, endDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()}};
    this.startDateMTD = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate(); 
    this.today =  (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate(); 
   }

  ngOnInit(): void { 
    var ss=window.location.pathname.split("/")
    this.prjcd=ss[2] 
    this.prjId = this.auth.getAuthentication().projectId  
    this.bindComplainResults("web")
    this.bindTodayCount("web")  
    // this.getComplainChartData(); 
    // this.complainCountByType();
    // this.complainCountZoneWise();
    // this.complainCountMonthWise();
    this.graphAndDetailsfunctions();
 
    
  }

  graphAndDetailsfunctions(){
    this.getVehTypeWisedata();
    this.getVehCategoryPrimSecTypeWisedata();
    this.getTimeDelayWishData();
    this.getBreakdownStatusgraph();
    this.getMonthBreakdownStatusgraph();
    this.getCostAndQtyData();
    this.getTopTenBreakdownReasonVehdetails();
    this.getEngineOildetails()
  }







  saveremarks(data){


     console.log('171',$('#field_'+data).val()); 

    
  }


  FullDetails(data){

     this.currentVehicleCatSlected = data;
    this.VehCatWiseDetsailsReort(data)

    $('#vehicleDetailsModal').modal('show');
  
  }
  VehCatWiseDetsailsReort(data) {
    
    this.loaderService.display(true); 
    this.http.get(environment.apiUrl + 'maintenance/VehCatWiseDetsailsReort?prjid=' + this.prjId+'&typename='+data).subscribe(data =>{ 
    this.VehcatTypeWisedata = data


    console.log('158',this.VehcatTypeWisedata);
    
    if(this.VehcatTypeWisedata.length>0){
      this.loaderService.display(false);
    }}, 
    error=>{ 
      this.loaderService.display(false);
      Swal({
        type: 'error',
        title: 'Oops...',
        text: 'An Error Occurred Please Try Again',
      })
    }); 
  }
  getVehTypeWisedata() {
    this.loaderService.display(true); 
    this.http.get(environment.apiUrl + 'maintenance/getVehTypeWisedata?prjid=' + this.prjId).subscribe(data =>{ 
    this.VehTypeWisedata = data
    
    this.vehCatGraphData = [];

    console.log('153',this.VehTypeWisedata);
    
    if(this.VehTypeWisedata.length>0){
      this.loaderService.display(false);
      for(var i=0; i<this.VehTypeWisedata.length; i++)
      {
        this.vehCatGraphData.push({
          'type':this.VehTypeWisedata[i].vehType.replace(/-/g,' '),
          'count':this.VehTypeWisedata[i].TOTAL,
          'totalCatCounts':this.VehTypeWisedata[i].totalCatCounts
        });
      }
      console.log('198',this.vehCatGraphData);
    }}, 
    error=>{ 
      this.loaderService.display(false);
      Swal({
        type: 'error',
        title: 'Oops...',
        text: 'An Error Occurred Please Try Again',
      })
    });  
  }
  
  getVehCategoryPrimSecTypeWisedata() {
    this.loaderService.display(true); 
    this.http.get(environment.apiUrl + 'maintenance/getVehCategoryPrimSecTypeWisedata?prjid=' + this.prjId).subscribe(data =>{ 
    this.PrimSecTypeWisedata = data
    
    this.PrimSecTypeGraphData = [];
      console.log('223',this.PrimSecTypeWisedata);

      
     
    if(this.PrimSecTypeWisedata.length>0){
      this.loaderService.display(false);
      for(var i=0; i<this.PrimSecTypeWisedata.length; i++)
      {
        this.PrimSecTypeGraphData.push({
          'type':this.PrimSecTypeWisedata[i].vehType.replace(/-/g,' '),
          'count':this.PrimSecTypeWisedata[i].TOTAL,
         });
      }
      console.log('198',this.vehCatGraphData);
    }}, 
    error=>{ 
      this.loaderService.display(false);
      Swal({
        type: 'error',
        title: 'Oops...',
        text: 'An Error Occurred Please Try Again',
      })
    });  
  }

  getTimeDelayWishData() {
    this.loaderService.display(true); 
    this.http.get(environment.apiUrl + 'maintenance/getTimeDelayWishData?prjid=' + this.prjId).subscribe(data =>{ 
    this.TimeDelayWishData = data


    console.log('203',this.TimeDelayWishData);
    
    if(this.TimeDelayWishData.length>0){

      
      this.FormattedTimeDelayWishData = [];

      for(var i=0; i<this.TimeDelayWishData.length; i++)
        {
             var splitIt = this.TimeDelayWishData[i].titles.split(" | ");

             this.FormattedTimeDelayWishData.push({
               'title':splitIt[0],
               'days':splitIt[1],
               'counts':this.TimeDelayWishData[i].counts
             });


        }

        console.log('215',splitIt);
        

      this.loaderService.display(false);
    }}, 
    error=>{ 
      this.loaderService.display(false);
      Swal({
        type: 'error',
        title: 'Oops...',
        text: 'An Error Occurred Please Try Again',
      })
    });  
  }


  getBreakdownStatusgraph(){
    this.loaderService.display(true); 
    this.http.get(environment.apiUrl + 'maintenance/getBreakdownStatusgraph?prjid=' + this.prjId).subscribe(data =>{ 
    this.BreakdownStatusgraph = data


    console.log('247',this.BreakdownStatusgraph);
    
    if(this.BreakdownStatusgraph.length>0){
      this.loaderService.display(false);
    }}, 
    error=>{ 
      this.loaderService.display(false);
      Swal({
        type: 'error',
        title: 'Oops...',
        text: 'An Error Occurred Please Try Again',
      })
    }); 


  }








  getReportBreakdownStatusgraph(){


    this.loaderService.display(true); 
    this.http.get(environment.apiUrl + 'maintenance/getReportBreakdownStatusgraph?prjid=' + this.prjId).subscribe(data =>{ 
    

    this.downloadExcelFile(data)
    this.loaderService.display(false); 

    }); 






  }

  getMonthBreakdownStatusgraph(){
    // let stdate = moment(this.startDateMTD).format('YYYY-MM-DD'); 
    // let enddate = moment(this.today).format('YYYY-MM-DD');


    let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD'); 


    this.monthsName = moment(this.defaultStartDate).format('MMMM')

    this.loaderService.display(true); 
    this.http.get(environment.apiUrl + 'maintenance/getMonthBreakdownStatusgraph?prjid=' + this.prjId+'&stdate='+stdate+'&enddate='+enddate).subscribe(data =>{ 
    this.MonthBreakdownStatusgraph = data






    this.monthsWisedata = [];

    for (let i = 0; i < this.MonthBreakdownStatusgraph.length; i++) {
     var  text =  this.MonthBreakdownStatusgraph[i]['dates'].substring(8); + "<br>";
      
      this.monthsWisedata.push({dates:text,total:this.MonthBreakdownStatusgraph[i]['total']})
      
    }

   
    


    
    if(this.MonthBreakdownStatusgraph.length>0){
      this.loaderService.display(false);
    }}, 
    error=>{ 
      this.loaderService.display(false);
      Swal({
        type: 'error',
        title: 'Oops...',
        text: 'An Error Occurred Please Try Again',
      })
    }); 


  }


  getReportMonthBreakdownStatusgraph(){

    let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD'); 

    
    this.loaderService.display(true); 

    this.http.get(environment.apiUrl + 'maintenance/getReportMonthBreakdownStatusgraph?prjid=' + this.prjId+'&stdate='+stdate+'&enddate='+enddate).subscribe(data =>{ 
       
           console.log('404',data);
           
      this.downloadExcelFile(data)

      this.loaderService.display(false); 
  
  } ); 
 }





  getCostAndQtyData(){

    let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');  

    console.log('343',stdate);
    console.log('344',enddate);

    this.http.get(environment.apiUrl + 'maintenance/getCostAndQtyData?prjid=' + this.prjId+'&todate='+stdate+'&fromdate='+enddate).subscribe(data =>{ 
      this.CostAndQtyData = data
  
  
      console.log('352',this.CostAndQtyData);


        // datetwo


        this.monthsWisedataTwo = [];

        for (let i = 0; i < this.CostAndQtyData.length; i++) {
         var  text =  this.CostAndQtyData[i]['dates'].substring(8); + "<br>";
          
          this.monthsWisedataTwo.push(
            {dates:text,
              TOTATAMOUNT:this.CostAndQtyData[i]['TOTATAMOUNT'],
              TOTALQYT:this.CostAndQtyData[i]['TOTALQYT']})
          
        }
    
        console.log('414',this.monthsWisedataTwo);










      
      if(this.CostAndQtyData.length>0){
        this.loaderService.display(false);
      }}, 
      error=>{ 
        this.loaderService.display(false);
        Swal({
          type: 'error',
          title: 'Oops...',
          text: 'An Error Occurred Please Try Again',
        })
      }); 

    
    


  }




  // getReportCostAndQtyData


  getReportCostAndQtyData(){

    let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');  

    this.loaderService.display(true); 

    this.http.get(environment.apiUrl + 'maintenance/getReportCostAndQtyData?prjid=' + this.prjId+'&todate='+stdate+'&fromdate='+enddate).subscribe(data =>{ 
    
      this.downloadExcelFile(data)
      this.loaderService.display(false); 
  }); 

}









  getTopTenBreakdownReasonVehdetails(){

    let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');  

    console.log('343',typeof(stdate));
    console.log('344',typeof(enddate));

    this.http.get(environment.apiUrl + 'maintenance/topTenBreakdownVehdetails?prjid=' + this.prjId+'&todate='+stdate+'&fromdate='+enddate).subscribe(data =>{ 
      this.topTenBreakdownVehdetails = data
  
  
      console.log('352',this.topTenBreakdownVehdetails);
      
      if(this.topTenBreakdownVehdetails.length>0){
        this.loaderService.display(false);
      }}, 
      error=>{ 
        this.loaderService.display(false);
        Swal({
          type: 'error',
          title: 'Oops...',
          text: 'An Error Occurred Please Try Again',
        })
      }); 

    
    


  }


  getEngineOildetails(){

    let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');  

    console.log('343',typeof(stdate));
    console.log('344',typeof(enddate));

    this.http.get(environment.apiUrl + 'maintenance/getEngineOildetails?prjid=' + this.prjId+'&todate='+stdate+'&fromdate='+enddate).subscribe(data =>{ 
      this.EngineOildetailsdata = data



  
  
       
      if(this.EngineOildetailsdata.length>0){

        this.engineOilGraphData =[{ 'title':'Received Oil','totals':this.EngineOildetailsdata[0].rcvoil },{ 'title':'Issued Oil','totals':this.EngineOildetailsdata[0].icoil }];

        console.log(this.engineOilGraphData);
        
        this.loaderService.display(false);
      }}, 
      error=>{ 
        this.loaderService.display(false);
        Swal({
          type: 'error',
          title: 'Oops...',
          text: 'An Error Occurred Please Try Again',
        })
      }); 

    
    


  }

  getReportEngineOildetails(){

    let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');  

    this.loaderService.display(true); 

    this.http.get(environment.apiUrl + 'maintenance/getReportEngineOildetails?prjid=' + this.prjId+'&todate='+stdate+'&fromdate='+enddate).subscribe(data =>{ 
          this.downloadExcelFile(data)
          this.loaderService.display(false); 
    
      }); 


  }



  // getReportEngineOildetails



  timeDelayDataview(data,title){

    this.gettimeDelayDataview(data,title)
     $('#timeDelayDataviewid').modal('show');
     

  }

  gettimeDelayDataview(data,title){
    this.currentVehicleCatSlected = title;
    this.loaderService.display(true); 
    this.http.get(environment.apiUrl + 'maintenance/gettimeDelayDataview?prjid=' + this.prjId+'&filterdatedata='+data).subscribe(data =>{ 
    this.filterDataDeatils = data


    console.log('282',this.filterDataDeatils);
    
    if(this.filterDataDeatils.length>0){
      this.loaderService.display(false);

     this.VehcatTypeWisedata=this.filterDataDeatils;
 
    $('#vehicleDetailsModal').modal('show');
    }}, 
    error=>{ 
      this.loaderService.display(false);
      Swal({
        type: 'error',
        title: 'Oops...',
        text: 'An Error Occurred Please Try Again',
      })
    }); 


  }


  getReporttimeDelayDataview(){
    
    this.loaderService.display(true); 
    this.http.get(environment.apiUrl + 'maintenance/getReporttimeDelayDataview?prjid=' + this.prjId).subscribe(data =>{ 
   

      this.downloadExcelFile(data)
   
      this.loaderService.display(false); 
  
    
    }); 


  }






   
/*
 * Bind All complain Chart
*/ 
bindComplainResults(type) { 
  let stdate = moment(this.defaultStartDate).format('YYYY-MM-DD');
  let enddate = moment(this.defaultEndDate).format('YYYY-MM-DD');  
  if(type == "web"){
  this.http.get(environment.apiUrl + "reports/getComplainDashBoardSummary?reportType="+type+"&prjId=" + this.prjId +"&frdt=" + stdate + "&todt=" + enddate).subscribe(data => {
    this.complainData = data 
    this.distinctZone=distinctZone(this.complainData)
    this.distinctWard=distinctWard(this.complainData)
    this.totalComplain = aggregateBy(this.complainData, this.aggregates)["Total"].sum;  
    this.todayTotal = aggregateBy(this.complainData, this.aggregates)["Today"].sum; 
    this.totPending = aggregateBy(this.complainData, this.aggregates)["Pending"].sum; 
    this.totResolved = aggregateBy(this.complainData, this.aggregates)["Resolved"].sum; 
    this.custMtdFeedBack=aggregateBy(this.complainData, this.aggregates)["FeedBack"].sum;
    this.custMtdUnderObser=aggregateBy(this.complainData, this.aggregates)["UnderObservation"].sum;
    this.gridDataComplainReport = process(this.complainData, this.state); 
    var total = 0
    var totalResolved = 0
    var totalPending = 0
    var totalFeedBack = 0
    var totalObs = 0 
    var cnt = 0
    this.complainData.forEach(element => {
      total += Number(element.Total)
      totalPending += Number(element.Pending)
      totalResolved += Number(element.Resolved)
      totalFeedBack += Number(element.FeedBack)
      totalObs += Number(element.UnderObservation)
      cnt += 1;
    });
    this.total = total 
    this.totalPending=totalPending
    this.totalResolved=totalResolved   
    this.custMtdFeedBack=totalFeedBack
    this.custMtdUnderObser=totalObs
    this.totalCNT = cnt
    if(this.total>0 || this.totalPending>0 || this.totalResolved>0){
      this.customChartNotFound=true
      this.customData = [
        { category: 'Total', value: this.total },
        { category: 'Pending', value: this.totalPending },
        { category: 'Resolved', value: this.totalResolved },
        { category: 'FeedBack', value: this.custMtdFeedBack },
        { category: 'UnderObservation', value: this.custMtdUnderObser }
      ]
    }
    else{
      this.customDataNotFound=true;
    } 
  }); 
}
// else 
// { 
//   alert('Alert')
//   window.open(environment.apiUrl + "reports/getComplainDashBoardSummary?prjid="+this.prjId+"&reportType=" + type +"&frdt=" + stdate + "&todt=" + enddate);
// } 
} 
/*
 * filter The Grid Data
*/
public dataStateChange(state: DataStateChangeEvent): void {
  this.state = state;
  this.gridDataComplainReport = process(this.complainData, this.state);  
  if (state && state.group) { 
    this.distinctZone=distinctZone(this.complainData)
    this.distinctWard=distinctWard(this.complainData)
    this.gridDataComplainReport = process(this.complainData, this.state); 
    this.totalComplain = aggregateBy(this.gridDataComplainReport.data, this.aggregates)["Total"].sum; 
    this.todayTotal = aggregateBy(this.complainData, this.aggregates)["Today"].sum; 
    this.totPending = aggregateBy(this.gridDataComplainReport.data, this.aggregates)["Pending"].sum; 
    this.totResolved = aggregateBy(this.gridDataComplainReport.data, this.aggregates)["Resolved"].sum;  
    } 
} 

/*
 * bind Today Data
*/ 
bindTodayCount(type) {
  let stdate = moment(this.startDateMTD).format('YYYY-MM-DD'); 
  let enddate = moment(this.today).format('YYYY-MM-DD'); 
  this.http.get(environment.apiUrl + "reports/getComplainDashBoardSummary?reportType=" +type +"&prjId="+this.prjId +"&frdt=" + enddate + "&todt=" + enddate).subscribe(data => {
    var complainData:any
    complainData = data;   
    var total = 0
    var totalResolved = 0
    var totalPending = 0
    var todayFeedBack=0;
    var todayObs=0;
    var cnt = 0
      complainData.forEach(element => {
      total += Number(element.Total)
      totalPending += Number(element.Pending)
      totalResolved += Number(element.Resolved)
      todayFeedBack += Number(element.FeedBack)
      todayObs += Number(element.UnderObservation)
      cnt += 1;
    });
    this.totalToday = total
    this.totalPendingToday = totalPending
    this.totalResolvedToday = totalResolved
    this.todayFeedBack = todayFeedBack
    this.todayObser = todayObs
    this.totalCNT = cnt 
    if(this.totalToday>0 || this.totalPendingToday>0 || this.totalResolvedToday>0){
      this.chartNotFound=true
      this.todayData = [
        { category: 'Total', value: this.totalToday },
        { category: 'Pending', value: this.totalPendingToday },
        { category: 'Resolved', value: this.totalResolvedToday },
        { category: 'FeedBack', value: this.todayFeedBack },
        { category: 'UnderObservation', value: this.todayObser}
        ] 
       } 
     else{ 
        this.dataNotFound=true; 
      }
  }); 
  // this.http.get(environment.apiUrl + "reports/getComplainDashBoardSummary?reportType=" +type +"&prjId="+this.prjId +"&frdt=" + stdate + "&todt=" + enddate).subscribe(data => {
  //  this.complainData = data  
  //  this.gridDataComplainReport = process(this.complainData, this.state); 
  //   var total = 0
  //   var totalResolved = 0
  //   var totalPending = 0
  //   var totalcustFeedBack=0;
  //   var totalcustObs=0;
  //   var cnt = 0
  //   this.complainData.forEach(element => {
  //     total += Number(element.Total)
  //     totalPending += Number(element.Pending)
  //     totalResolved += Number(element.Resolved)
  //     totalcustFeedBack += Number(element.FeedBack)
  //     totalcustObs += Number(element.UnderObservation)
  //     cnt += 1;
  //   });
  //   this.totalMTD = total
  //   this.totalPendingMTD = totalPending
  //   this.totalResolvedMTD = totalResolved
  //   this.totalCustFeedBack = totalcustFeedBack
  //   this.totalCustUnderOb = totalcustObs
  //   this.totalCNT = cnt
  //   if(this.totalMTD>0 ||this.totalPendingMTD>0 || this.totalResolvedMTD>0){
  //     this.mtdData = [
  //       { category: 'Total', value: this.totalMTD },
  //       { category: 'Pending', value: this.totalPendingMTD },
  //       { category: 'Resolved', value: this.totalResolvedMTD },
  //       { category: 'FeedBack', value: this.totalCustFeedBack },
  //       { category: 'UnderObservation', value: this.totalCustUnderOb}
  //     ] 
  //   }else{ 
  //     this.customDataNotFound=true; 
  //   }
  // }); 
} 



/**
 * Filter Data details
*/
  onDateRangeChanged(dateRange){  
    if(dateRange.beginDate.day>0){ 
      this.defaultStartDate= dateRange.beginDate.year + "-"  + dateRange.beginDate.month+ "-" + dateRange.beginDate.day 
      this.defaultEndDate = dateRange.endDate.year + "-"  + dateRange.endDate.month  + "-" + dateRange.endDate.day 
      this.bindComplainResults("web") ;

      this.getMonthBreakdownStatusgraph()

      this.getCostAndQtyData();
    }else if(dateRange.beginDate.day==0){
      this.defaultStartDate= this.defaultStartDate
      this.defaultEndDate = this.defaultEndDate
      this.bindComplainResults("web") ;
      this.getCostAndQtyData;
      this.getMonthBreakdownStatusgraph()
    } 
  } 

   



  downloadExcelFile(reportdata) {
    const ws_name = 'VehicleInfo';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(reportdata);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'VehicleInfo.xlsx');
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }






















}











// WEBPACK FOOTER //
// ./src/app/maintenance/maintenanceSummary/maintenanceSummaryDashboard/summary.component.ts